var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemalePaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 386,
    fill: "none",
    viewBox: "0 0 155 386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M125.558 205.488L125.077 204.903C119.529 199.175 110.414 199.046 104.719 204.616C99.0236 210.183 98.9073 219.34 104.452 225.066L118.585 239.653L111.065 260.668C108.375 268.181 112.262 276.469 119.745 279.177C127.229 281.885 135.473 277.991 138.161 270.477C145.225 248.081 140.478 223.602 125.558 205.488",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M81.1848 183.071C54.5689 185.074 34.6279 208.372 36.6473 235.114L37.4103 249.244C39.4328 275.986 62.6425 296.039 89.2616 294.035C115.878 292.033 135.817 268.735 133.798 241.992L133.033 227.864C131.014 201.12 107.8 181.067 81.1848 183.071",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_203",
    width: 115,
    height: 339,
    x: 7,
    y: -108,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M121.912 221.882L42.1601 230.264L7.56915 -98.8472L87.3206 -107.229L121.912 221.882Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_203)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M103.992 194.679L90.3443 -78.4613C88.6745 -94.3482 59.6052 -104.316 43.7911 -102.654C27.9769 -100.992 8.92302 -85.966 10.5928 -70.0791L46.7251 200.698C48.3951 216.587 62.5679 228.119 78.3821 226.457C94.1962 224.795 105.662 210.568 103.992 194.679",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3_203",
    width: 122,
    height: 360,
    x: 13,
    y: -109,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M134.754 241.891L50.2957 250.768L13.4843 -99.4688L97.9425 -108.346L134.754 241.891Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3_203)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M100.138 191.679C96.0879 189.937 93.9438 185.399 93.7305 180.98L80.6367 -68.7675C78.9669 -84.6547 42.309 -93.8228 26.4949 -92.1607C22.1609 -91.7052 18.1728 -90.2814 14.6726 -88.1628C19.1856 -95.5746 34.5223 -101.68 43.7914 -102.654C59.6055 -104.316 88.6748 -94.348 90.3446 -78.4612L102.905 181.699C103.044 184.582 104.709 187.158 107.254 188.501C121.516 196.029 134.94 210.022 133.798 241.992C133.798 241.992 134.831 206.6 100.138 191.679",
    clipRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M130.052 256.629C129.58 250.351 124.138 245.641 117.883 246.101C111.62 246.564 106.912 252.04 107.369 258.332L110.336 299.157C110.337 299.166 114.317 352.099 114.317 352.107C114.79 358.387 120.231 363.097 126.485 362.637C132.75 362.175 137.456 356.698 137 350.406L130.054 256.659C130.054 256.651 130.053 256.64 130.052 256.629",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M106.177 272.449C105.705 266.171 100.264 261.461 94.0085 261.921C87.7452 262.384 83.0375 267.86 83.4946 274.152L86.4614 314.977C86.4621 314.986 90.4425 367.919 90.443 367.927C90.9153 374.207 96.3567 378.917 102.611 378.458C108.875 377.995 113.582 372.518 113.125 366.227L106.18 272.479C106.179 272.471 106.178 272.46 106.177 272.449",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M84.6383 263.256C84.4954 256.963 79.3079 251.974 73.0371 252.106C66.7582 252.24 61.7703 257.463 61.8975 263.77L62.7236 304.694C62.7239 304.703 63.9285 357.772 63.9285 357.78C64.0716 364.076 69.259 369.065 75.5286 368.933C81.8087 368.799 86.7955 363.576 86.6686 357.269L84.6391 263.286C84.6388 263.278 84.6384 263.267 84.6383 263.256",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M133.336 349.117C133.336 349.117 130.255 248.731 130.726 255.009C130.727 255.019 130.728 255.03 130.729 255.039L137.674 348.786C138.131 355.078 133.425 360.554 127.16 361.017C126.43 361.071 125.712 361.048 125.01 360.966C130.144 359.55 133.738 354.652 133.336 349.117",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M109.461 364.937C109.461 364.937 106.38 264.551 106.852 270.829C106.853 270.84 106.854 270.85 106.854 270.859L113.8 364.606C114.257 370.898 109.55 376.374 103.285 376.837C102.556 376.891 101.837 376.868 101.136 376.786C106.269 375.37 109.864 370.472 109.461 364.937",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M83.2892 355.206C83.2892 355.206 85.4659 254.797 85.6085 261.09C85.6089 261.101 85.609 261.112 85.6093 261.12L87.6388 355.103C87.766 361.41 82.7793 366.632 76.4989 366.767C75.7675 366.782 75.0513 366.722 74.3549 366.603C79.5552 365.458 83.4011 360.755 83.2892 355.206",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M60.9681 243.658C60.7075 237.374 56.2716 232.324 51.0482 232.373C45.8177 232.423 41.7778 237.57 42.0254 243.867L43.6343 284.731C43.6345 284.74 45.8317 337.731 45.8319 337.74C46.0925 344.027 50.5284 349.076 55.751 349.028C60.9825 348.977 65.0214 343.83 64.7736 337.533L60.9693 243.688C60.9691 243.679 60.9685 243.669 60.9681 243.658",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M60.9644 337.326C60.9644 337.326 63.4249 268.733 63.4252 268.742L65.3136 337.205C65.4782 343.511 60.5228 348.754 54.2434 348.915C53.5119 348.933 52.7952 348.875 52.0984 348.759C57.292 347.593 61.1096 342.874 60.9644 337.326Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4EAA",
    fillRule: "evenodd",
    d: "M118.539 359.807L117.23 346.963C117.079 345.555 117.33 344.134 117.954 342.864C119.823 339.059 124.383 337.669 127.973 339.507C128.632 339.844 129.221 340.305 129.75 340.825C131.352 342.399 132.314 344.516 132.45 346.765L133.406 357.394L132.878 358.103C129.463 362.689 122.922 363.466 118.539 359.807",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4EAA",
    fillRule: "evenodd",
    d: "M94.6646 375.627L93.355 362.783C93.2046 361.376 93.4559 359.954 94.0794 358.684C95.9487 354.879 100.508 353.489 104.098 355.327C104.757 355.665 105.347 356.125 105.876 356.645C107.478 358.219 108.44 360.336 108.575 362.585L109.532 373.214L109.003 373.924C105.588 378.509 99.0473 379.286 94.6646 375.627",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4EAA",
    fillRule: "evenodd",
    d: "M67.1575 364.588L66.5219 351.693C66.4454 350.28 66.7708 348.873 67.4598 347.638C69.5258 343.935 74.1518 342.786 77.6405 344.809C78.2813 345.181 78.8456 345.671 79.3466 346.218C80.8642 347.875 81.7142 350.039 81.7316 352.291L82.1308 362.956L81.5658 363.637C77.9154 368.038 71.3428 368.471 67.1575 364.588",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4EAA",
    fillRule: "evenodd",
    d: "M47.2396 345.429L46.8612 332.523C46.8128 331.108 47.1662 329.709 47.88 328.489V328.489C50.0191 324.834 54.6673 323.786 58.115 325.886C58.7478 326.271 59.3024 326.774 59.7924 327.332C61.2765 329.021 62.0834 331.204 62.0559 333.456L62.2422 344.127L61.664 344.795C57.9265 349.115 51.3464 349.404 47.2396 345.429",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB600",
    strokeWidth: 1.701,
    d: "M101.416 171.618C129.418 153.451 18.2026 178.544 32.5713 193.881C34.7075 196.161 43.7917 194.928 46.9675 193.807"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB600",
    strokeWidth: 1.701,
    d: "M42.0585 176.766C7.17918 181.111 110.078 128.351 110.849 149.183C110.964 152.281 103.178 157.206 99.9329 158.407"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemalePaper);
export default __webpack_public_path__ + "static/media/female_paper.1f660b64fe0b061ab27c36d7f4b3701f.svg";
export { ForwardRef as ReactComponent };